/**
 * Purchasable object
 */
const yup = require('yup');

const {
  requiredString,
  validateObject,
  requiredObject,
  optionalString,
  requiredBool,
  requiredArrayOf
} = require('../utils');

const COLLECTION = 'attributes';
const SCHEMA = yup.object().shape({
  name: requiredString(),
  icon: optionalString(),
  required: requiredBool().default(false),
  type: requiredString().oneOf(["many", "one"]).default("many"),
  options: requiredArrayOf(requiredObject().shape({
    name: requiredString(),
    icon: optionalString(),
    value: requiredString(),
    oldId: optionalString(),
    oldGroupId: optionalString(),
    groupName: optionalString()
  }))
});

async function validate(attribute) {
  return validateObject(SCHEMA, attribute);
}

module.exports = {
  COLLECTION,
  SCHEMA,
  validate
};